module.exports = __webpack_public_path__ + "img/bnner_1.6d88d68f.webp";